export const TEAM_ROUTE = {
  team: {
    path: '/team'
  }
};
